export const enum RelationStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Finished = 'finished',
  MinLeft30 = '30_min_left',
  MinLeft5 = '5_min_left',
}
